<style>
    @import './assets/index.less';

    .admintag {
        background-color: #333;
        color: #fff;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        margin-right: 10px;
    }

    .zengpin {
        border: 1px solid #20bf64;
        border-radius: 4px;
        width: 18px;
        height: 16px;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        line-height: 16px;
        color: #20bf64;
        margin-left: 8px;
        margin-right: 8px;
    }

    .admintag:hover {
        cursor: pointer;
    }

    .ivu-drawer-body {
        padding: 0;
    }
</style>

<template>
    <div id="app" style="min-height:calc(100vh - 261px);">
        <div v-if="loading" style="width:100vw;height:100vh;z-index: 999;;display: flex;align-items: center;justify-content: center;position: fixed;left: 0;top: 0;background-color: rgba(255, 255, 255, 0.8);">
            <Spin></Spin>
        </div>
        <template v-if="gengxinrizhiModal.displayed">
            <Drawer v-model="gengxinrizhiModal.display" style="z-index: 999;" placement="right" width="440" :closable="false" :scrollable="false" @on-visible-change="gengxinrizhiModal.displayChanged">
                <Updatelog ref="updatelogref" :current="gengxinrizhiModal.current" />
            </Drawer>
        </template>
        <template v-if="isPublicRoute">
            <router-view></router-view>
        </template>
        <template v-else>
        <div style="height:60px;width:100%;z-index: 9;display: flex;justify-content: space-between;align-items: center;background-color: #fff;border-bottom: 1px solid #f1f1f1;">
            <div style="font-size: 24px;font-weight: bold;line-height: 60px;padding-left: 20px;display: flex;align-items: center;">
                <!-- <div style="background-color: #333;color: #fff;border-radius: 4px;width:32px;height: 32px;margin-right: 12px;" class="center">G</div> -->
                <img src="//cdn.igyl.com/vendor-statics/k.png" style="width: 32px;height: 32px;display: block;border-radius: 4px;margin-right: 12px;">
                <div>供应链 · {{(session && session.jigou)?'智能版':'总后台'}}</div>
                <div @click="gengxinrizhiModal.show" class="admintag center" style="background-color: #f5f5f5;border-radius: 16px;margin-left: 20px;padding: 4px 8px;height: 30px;color: #333;">
                    <Badge :dot="newversiontip" :offset="[20,-6]" v-if="session">
                        <Icon type="md-list-box" /> {{localcv || '1.0.0'}}
                    </Badge>
                </div>
            </div>
            <div style="padding-right: 20px;display: flex;align-items: center;" v-if="session && session.zhanghao">
                <div v-if="session.sysadmin" class="admintag">超级管理员：{{session.sysadmin}}</div>
                <Dropdown placement="bottom-end" trigger="click" @on-visible-change="loadZhanghaos">
                    <div id="current_jigou" style="display: flex;align-items: center;margin-right: 20px;" class="hover">
                        <div style="text-align: right;">
                            <div>{{session.jigou?session.jigou.name:'总后台'}}</div>
                            <!-- <div style="color: #aaa;font-size: 12px;">{{session.jigou?session.jigou.code:''}}</div> -->
                        </div>
                        <Icon type="ios-arrow-down" style="margin-left: 4px;" />
                    </div>
                    <DropdownMenu slot="list">
                        <div style="text-align: center;color: #aaa;padding-top: 10px;">切换身份</div>
                        <div style="padding: 7px 16px;" v-if="session.sysadmin">
                            <Input v-model="sysadminphone" placeholder="更换到手机号" @on-enter="loadZhanghaos" search style="width: 300px" />
                        </div>
                        <div style="padding: 7px 16px;" id="account_search_wapper">
                            <Input ref="account_search" v-model="shopsName" placeholder="搜索" @input="shopInput" search style="width: 300px" />
                        </div>
                        <div v-if="accounts.length>=1" style="max-height: 500px;overflow-y: auto;">
                            <div v-for="(item,index) in accounts" :key="index" @click="toSwitch(item)">
                                <DropdownItem v-if="item._id!=session.zhanghao._id && item.actived && !item.deleted && (!item.jituan || item.jituan.actived !== false) && (!item.jigou || (item.jigou.actived === undefined || item.jigou.actived))" :key="index">
                                    <div>
                                        <div style="max-width: 300px;" class="nowrap">{{item.jigou?item.jigou.name:'总后台'}}</div>
                                        <div style="color: #aaa;" v-if="item.jueses && item.jueses[0]">{{item.jueses.map(i=>{return i.name}).join(',')}}</div>
                                        <div style="color: #aaa;" v-if="session.sysadmin">{{item.name}}({{item.user?item.user.phone:''}})</div>
                                    </div>
                                </DropdownItem>
                            </div>

                        </div>
                        <div v-else style="padding: 16px;text-align: center;">
                            暂无数据
                        </div>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown placement="bottom-end" trigger="click">
                    <div id="current_account" style="display: flex;align-items: center;" class="hover">
                        {{session.zhanghao.name}}
                        <Icon type="ios-arrow-down" style="margin-left: 4px;" />
                    </div>
                    <DropdownMenu slot="list">
                        <DropdownItem v-if="session.jigou">
                            <div @click="toProfile">
                                个人中心
                            </div>
                        </DropdownItem>
                        <!-- <DropdownItem>
                            <div @click="reloadMenus">
                                更新菜单
                            </div>
                        </DropdownItem>
                        -->
                        <DropdownItem>
                            <div @click="logout">
                                退出
                            </div>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </div>
        <div>
            <div id="container" v-if="session && session.zhanghao" style="display: flex;">
                <div style="width: 200px;height: calc(100vh - 60px);overflow-y: scroll;">
                    <Menu ref="menus" @on-select="mendSelect" :active-name="active_menu" theme="light" width="auto" :open-names="active_menugroup" style="min-height: calc(100vh - 60px);" accordion>
                        <Menu-item class="menu-item" name="0" to="/">
                            <Icon type="ios-grid-outline" size="16" />
                            <span style="margin-left: 2px;">首页</span>
                        </Menu-item>
                        <Submenu :name="item.key" v-for="(item,index) in session.menuGroups" :key="index">
                            <template slot="title">
                                <Icon type="ios-grid-outline" size="16" />
                                <Badge :count="groupbadge[item.code]" overflow-count="99" v-if="groupbadge">
                                    {{item.name}}
                                </Badge>
                                <span v-else>{{item.name}}</span>
                            </template>
                            <Menu-item v-for="(menu,index) in item.menus" :key="index" :to="menu.path" class="menu-item" style="background-color: #fafafa;margin-left: 16px;" :name="menu.key">
                                <Badge :count="session.badge[item.code]?session.badge[item.code][menu.code]:0" overflow-count="99" v-if="session.badge">
                                    <span>{{menu.name}}</span>
                                </Badge>
                                <span v-else>{{menu.name}}</span>
                            </Menu-item>
                        </Submenu>
                    </Menu>
                </div>
                <div style="width: calc(100vw - 200px);height: calc(100vh - 60px);overflow-y: scroll;">
                    <div id="app">
                        <div class="app-nav" style="height: 40px; position: fixed; background: #fff; top: 60px; left: 200px; width: calc(100vw - 216px); z-index: 99;">
                            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag" />
                        </div>
                        <div class="app-nav-padding" style="height: 30px;"></div>
                        <keep-alive :exclude="excludeCache" :max="15">
                            <router-view ref="main" :activeMenu="active_menu"></router-view>
                        </keep-alive>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="session && !session.zhanghao" class="center" style="margin-top:200px">
            <div style="text-align: center;background-color: #fff; border: 1px solid rgb(241, 241, 241); min-height: 392px; width: 415px">
                <div style="background-color: #f7f8fa;font-weight: bold;padding: 10px;font-size: 20px;">系统登录</div>
                <div style="display: flex;justify-content: space-between;padding: 10px;">
                    <div :style="'width:50%;padding: 10px 0;'+(form.type=='scan'?'border-bottom:4px solid #20bf64;font-weight:bold;':'border-bottom:1px solid #f1f1f1')" class="hover" @click="form.type='scan';loadLoginCode()">扫码登录</div>
                    <div :style="'width:50%;padding: 10px 0;'+(form.type=='phone'?'border-bottom:4px solid #20bf64;font-weight:bold;':'border-bottom:1px solid #f1f1f1')" class="hover" @click="form.type='phone'">手机登录</div>
                </div>
                <div style="margin-top: 20px;" v-if="form.type=='phone'">
                    <div style="padding: 10px;">
                        <Input v-model="form.phone" size="large" placeholder="请输入手机号" />
                    </div>
                    <div style="padding: 10px;" class="jcsb">
                        <Input v-model="form.code" size="large" placeholder="请输入验证码" />
                        <Button type="primary" size="large" style="margin-left: 10px;width:200px;" :loading="logining" :disabled="!!(!form.phone || codeCD)" @click="getCode">{{codeCD?('重新获取（'+codeCD+'）'):'获取验证码'}}</Button>
                    </div>
                    <Button type="primary" size="large" style="width: 380px;margin-top: 40px; margin-bottom: 20px" :loading="logining" :disabled="!codeSend" @click="login">登录</Button>
                </div>
                <div style="margin-top: 20px;" v-if="form.type=='scan'">
                    <div v-if="!scanSuccess">
                        <div style="padding: 10px;" class="center">
                            <img v-if="loginCode" :src="loginCode.url" style="width: 200px;height: 200px;" />
                        </div>
                        <div style="color: #aaa;" v-if="loginCode">请使用微信扫码</div>
                        <div style="color: #aaa;" v-if="!loginCode">正在加载二维码</div>
                    </div>
                    <div v-else style="text-align: center;padding: 20px 0;">
                        <Icon type="ios-checkmark-circle" style="color: #20bf64;font-size: 80px;" />
                        <div style="height: 20px;"></div>
                        <div style="font-size: 20px;">已完成扫码</div>
                        <div @click="resetQrcode" class="hover" style="color: #20bf64;font-weight: bold;">重新获取</div>
                    </div>
                    <!-- <div style="padding: 10px;height:200px;color: #aaa;background-color: #fafafa;" class="center">
                        暂不支持
                    </div> -->
                </div>
            </div>
            <div style="position: absolute;bottom: 20px;">
                <div style="width: 100%; display: flex; flex-direction: column; align-items: center">
                    <p>
                    </p>
                    <div style="color: #8d8d8d; margin: 0 0 5px 0;">Copyright © 2020-2030 All rights reserved.</div>
                    <a href="http://beian.miit.gov.cn/" style="color: #8d8d8d; text-decoration: none; margin: 0 0 5px 0;">浙ICP备18054766号</a>
                    <!-- <div style="color: #8d8d8d; margin: 0 0 5px 0;">杭州夕习喜兮信息科技有限公司</div> -->
                    <p></p>
                </div>
            </div>
        </div>
        <Modal v-model="profileModal" class="nopadding" footer-hide :width="750">
            <ProfileForm ref="profileForm" v-if="profileModal" v-on:cancel="profileModal=false;" v-on:dataChanged="profileModal=false;"></ProfileForm>
        </Modal>
        </template>
    </div>
</template>
<script>
    import ProfileForm from '@/components/common/ProfileForm.vue'
    import Updatelog from '@/components/common/Updatelog.vue'
    import TagsNav from '@/components/common/tagsNav.vue'
    import { mapMutations } from 'vuex'
    import { getNewTagList, routeEqual } from '@/utils/nav'
    export default {
        components: {
            ProfileForm,
            TagsNav,
            Updatelog,
        },
        data() {
            return {
                accounts: [],
                shopsName: '',
                scrollMaxRight: 0,
                session: null,
                form: {
                    phone: null,
                    code: null,
                    type: 'phone',
                },
                username: null,
                password: null,
                active_menu: '0-1',
                active_menugroup: ['0'],
                profileMenusVisible: false,
                todoCount: 0,
                audio_order: new Audio("https://cdn.igyl.com/vendor-statics/club/audio/order.mp3"),
                permissions: {},
                logining: false,
                codeSend: false,
                codeCD: 0,
                loading: false,
                profileModal: false,
                loginCode: null,
                scanSuccess: false,
                showNav: true,
                sysadminphone: '',
                gengxinrizhiModal: {
                    display: false,
                    displayed: false,
                    current: null,
                    show: () => {
                        this.gengxinrizhiModal.current = this.localcv_viewed
                        sessionStorage.cv_viewed = this.session.cv
                        this.localcv_viewed = this.session.cv
                        this.newversiontip = false
                        this.gengxinrizhiModal.displayed = true
                        setTimeout(() => {
                            this.gengxinrizhiModal.display = true
                        }, 30);
                        // if (this.gengxinrizhiModal.current < this.session.cv && this.$refs.updatelogref) {
                        if (version1gtversion2(this.session.cv, this.gengxinrizhiModal.current) && this.$refs.updatelogref) {
                            this.$refs.updatelogref.refresh()
                        }
                    },
                    displayChanged: (visiable) => {
                        if (!visiable && this.$store.auto_update) {
                            sessionStorage.updateTip = true
                            window.location.reload()
                        }
                    }
                },
                localcv: '',
                localcv_viewed: '',
                newversiontip: false,
            }
        },
        watch: {
            $route: {
                handler(to, from) {
                    if (this.isPublicPath(to && to.path)) {
                        return
                    }
                    if (from && this.isPublicPath(from.path) && !this.session) {
                        return this.loadSession({
                            cb: () => {
                                this.processRoute(to)
                            }
                        })
                    }
                    //this.$router.push跳转时没有高亮只针对出入库汇总跳转物品出入库明细
                    if (to.path == '/web/sjbb/wpcrkmx' && from.path == '/web/sjbb/crkhz') {
                        this.active_menu = '7-6'
                    }
                    // 如果标签列表为空，先从 localStorage 恢复
                    if (this.tagNavList.length === 0) {
                        this.setTagNavList(null)
                        // 等待标签列表恢复后再继续处理
                        this.$nextTick(() => {
                            this.processRoute(to)
                        })
                    } else {
                        this.processRoute(to)
                    }
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            isPublicRoute() {
                return this.isPublicPath((this.$route && this.$route.path) || '')
            },
            groupbadge() {
                let r = {}
                if (this.session.badge) {
                    for (let key of Object.keys(this.session.badge)) {
                        r[key] = 0
                        for (let value of Object.values(this.session.badge[key])) {
                            r[key] += value
                        }
                        if (r[key] < 0) r[key] = 0
                    }
                }
                return r
            },
            tagNavList() {
                return this.$store.state.tagsNav.tagNavList || []
            },
            // 不需要缓存的页面(组件)
            excludeCache() {
                return [
                    'HomePage',
                    'mallDress'
                ]
            }
        },
        created: function() {
            let that = this
            // 在初始化时先从 localStorage 恢复标签列表
            if (this.$store.state.tagsNav.tagNavList.length === 0) {
                this.setTagNavList(null) // 传入 null 会从 localStorage 读取
            }
            if (process.env.NODE_ENV !== 'production' && window.location.href.indexOf('demo=1') >= 0) {
                let demoButtons = ['查看', '保存', '审核', '分享', '确认', '下推', '关闭', '删除', '打印'].map((name, index) => ({ name, key: `demo-${index}`, actived: true }))
                let demoSession = {
                    token: 'quotation-demo',
                    cv: '2.4.1',
                    badge: { psgh: { xsbjd: 0 } },
                    zhanghao: { _id: 'demo-account', name: '演示销售', jigou: { _id: 'demo-center', name: '成都中央配送中心', type: 'PS' } },
                    jigou: { _id: 'demo-center', name: '成都中央配送中心', type: 'PS' },
                    menuGroups: [{ name: '配送供货', code: 'psgh', key: '1', menus: [{ name: '销售报价', code: 'xsbjd', key: '1-3', group: '1', path: '/web/psgh/xsbjd', buttons: demoButtons }] }],
                }
                if (window.location.hash.split('?')[0] === '#/web/psyh/xsbjd') {
                    demoSession.jigou = { _id: 'c1', name: '豪侠汇餐厅 · 天府店', type: 'MD' }
                    demoSession.zhanghao.jigou = demoSession.jigou
                    demoSession.zhanghao.name = '演示店长'
                    if (window.location.hash.includes('demoOrg=zb')) {
                        demoSession.jigou = { _id: 'demo-headquarters', name: '演示总部', type: 'ZB' }
                        demoSession.zhanghao.jigou = demoSession.jigou
                        demoSession.zhanghao.name = '演示管理员'
                    }
                    demoSession.menuGroups = [{ name: '配送要货', code: 'psyh', key: '2', menus: [{ name: '销售报价', code: 'xsbjd', key: '2-11', group: '2', path: '/web/psyh/xsbjd', buttons: demoButtons }] }]
                }
                this.$store.session = demoSession
                this.session = demoSession
            } else if (!this.isPublicRoute) {
                that.loadSession({
                    cb: function(session) {
                        that.localcv_viewed = sessionStorage.cv_viewed || ''
                        that.localcv = session.cv || ''
                        if (version1gtversion2(session.cv, that.localcv_viewed)) {
                            that.newversiontip = true
                        }
                        if (sessionStorage.updateTip === 'true' || sessionStorage.updateTip === true) {
                            sessionStorage.updateTip = false
                            that.$Notice.success({
                                title: '系统已更新',
                                duration: 5,
                                render: h => {
                                    return h('span', [
                                        '检测到新版本，系统已自动完成更新',
                                        h('Button', {
                                            props: {
                                                type: 'text',
                                                size: 'small'
                                            },
                                            style: {
                                                marginLeft: '-8px',
                                                color: '#20bf64',
                                                marginTop: '8px',
                                            },
                                            on: {
                                                click: () => {
                                                    that.gengxinrizhiModal.show()
                                                }
                                            }
                                        }, '查看更新内容')
                                    ])
                                }
                            });
                        }
                    }
                })
            }
            if (window.location.host == 'dev.gylzl.com') {
                if (window.document.title.indexOf('[dev]') == -1) window.document.title = window.document.title + ' [dev]'
            } else if (window.location.host == 'test.gylzl.com') {
                window.document.title = window.document.title + ' [test]'
            } else if (window.location.host == 'qa.gylzl.com') {
                window.document.title = window.document.title + ' [qa]'
            } else if (window.location.host == 'pre.gylzl.com') {
                window.document.title = window.document.title + ' [pre]'
            }
            window.document.body.onkeydown = function(e) {
                if (e.code == 'F5') {
                    e.preventDefault()
                    if (that.$refs.main && that.$refs.main.loadData) that.$refs.main.loadData()
                    that.$Message.success('数据已更新')
                }
                if (that.$refs.main && that.$refs.main.onkeydown) that.$refs.main.onkeydown(e)
            }
            window.document.addEventListener('sessionUpdated', function() {
                that.loadSession({
                    cb: function(session) {
                        that.session = session
                    }
                })
            })
            window.document.body.onhashchange = function(e) {
                that.updateMenu(e)
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleTableScroll, true); // 坑-必须加上true，否则监听不上
        },
        sockets: {
            connect: function() {
                console.log('socket connected')
                if (this.session && this.session.token) {
                    this.$socket.emit('join', this.session.token || 1);
                } else {
                    this.socketReady = true
                }
            },
            event: function(res) {
                console.log(res)
                let { event, changes, type, details } = res.data
                switch (event) {
                    case 'CLIENT_VERSION_CHANGED':
                        this.session.cv = res.data.version
                        this.$store.session.cv = res.data.version
                        // if (this.session.cv > this.localcv) {
                        if (version1gtversion2(this.session.cv, this.localcv)) {
                            this.$store.auto_update = true // 将在下次list请求时刷新页面
                        }
                        // if (this.session.cv > this.localcv_viewed) {
                        if (version1gtversion2(this.session.cv, this.localcv_viewed)) {
                            this.newversiontip = true
                        }
                        break;
                    case 'SESSION_CHANGE':
                        /**session改动 */
                        this.loadSession({ dataChanged: true, changes })
                        break;
                    case 'BADGE_CHANGE':
                        /**session改动 */
                        this.loadSession({ badgeChanged: true, changes })
                        break;
                    case 'BADGE_CHANGE_LOCAL':
                        /**session改动 */
                        if (details) {
                            for (let detail of details) {
                                this.session.badge[detail.group][detail.menu] = this.session.badge[detail.group][detail.menu] || 0
                                this.session.badge[detail.group][detail.menu] += detail.amount
                                if (this.session.badge[detail.group][detail.menu] < 0) this.session.badge[detail.group][detail.menu] = 0
                                // this.groupbadge[detail.group] += detail.amount
                                // if (this.groupbadge[detail.group] < 0) this.groupbadge[detail.group] = 0
                            }
                        }
                        break;
                    case 'OA_AUTH':
                        /**授权二维码 */
                        if (this.$refs['main'] && this.$refs['main'].getAuthResult) {
                            this.$refs['main'].getAuthResult(res)
                        }
                        break;
                    default:
                        if (type == 'bind' || type == 'unbind') {
                            if (this.$refs['profileForm'] && this.$refs['profileForm'].qrcodeScaned) this.$refs['profileForm'].qrcodeScaned(res)
                            if (this.$refs['main'] && this.$refs['main'].qrcodeScaned) this.$refs['main'].qrcodeScaned(res)
                        } else if (type == 'login') {
                            this.loginbyQrcode(res)
                        }
                        break;
                }


                //用进度条提醒页面已收到ws消息
                this.$Loading.start()
                this.$Loading.finish()

            }
        },
        methods: {
            isPublicPath(path) {
                return path === '/docs' || (path && path.indexOf('/docs/') === 0) || path === '/sales-quotation'
            },
            ...mapMutations([
                'setTagNavList',
                'addTag',
                'setLocal',
                'setHomeRoute',
                'closeTag',
                'clearTag'
            ]),
            async loadZhanghaos(visiable) {
                if (!visiable) { return }
                if (!this.zhanghaos) {
                    this.loading = true
                }
                let res = await this.$api.post('/web/main/zhanghaos/load', {
                    sysadminphone: this.sysadminphone,
                })
                this.loading = false
                if (res.data.success) {
                    this.zhanghaos = res.data.zhanghaos
                    this.accounts = this.zhanghaos
                    this.shopsName = ''
                }
            },
            shopInput(val) {
                this.accounts = this.zhanghaos.filter(row => {
                    let name = row.jigou ? row.jigou.name || '' : '总后台'
                    return name.indexOf(val) != -1
                })
            },
            async loginbyQrcode(res) {
                if (res.data.error) {
                    this.$Message.error(res.data.error)
                } else {
                    this.form = { type: 'scan', qrcode: res.data.qrcode }
                    this.scanSuccess = true
                    this.login()
                }
            },
            resetQrcode() {
                this.scanSuccess = false
                this.loginCode = null
                this.loadLoginCode()
            },
            async loadLoginCode() {
                if (!this.loginCode) {
                    this.loadingCode = true
                    let res = await this.$api.post('/web/main/qrcode/load', {
                        type: 'login'
                    })
                    this.loginCode = res.data.qrcode
                    // this.loginCode = {url:'https://cdn.igyl.com/vendor-statics/qrcode_for_gh_88fe6cc99f1b_1280-2.jpg'}
                    this.loadingCode = false
                }
            },
            // 这里是控制table滚动阴影-结合index.css
            handleTableScroll() {
                let tableEl = document.querySelector('.ivu-table-wrapper .ivu-table-overflowX')
                let leftFixedEl = document.querySelector('.ivu-table-wrapper .ivu-table-fixed')
                let rightFixedEl = document.querySelector('.ivu-table-wrapper .ivu-table-fixed-right')
                if (tableEl && tableEl.scrollLeft > 0) {
                    if (leftFixedEl) {
                        leftFixedEl.className = 'ivu-table-fixed shadow-show'
                    }
                    if (rightFixedEl) {
                        rightFixedEl.className = 'ivu-table-fixed-right shadow-show'
                    }
                    // 判断是否滚动到底 - todo
                } else {
                    if (leftFixedEl) {
                        leftFixedEl.className = 'ivu-table-fixed shadow-hide'
                    }
                    if (rightFixedEl) {
                        rightFixedEl.className = 'ivu-table-fixed-right shadow-hide'
                    }
                }
            },
            reload() {
                this.isRouterAlive = false; //先关闭，
                this.$nextTick(() => {
                    this.isRouterAlive = true; //再打开
                })
            },

            toProfile() {
                this.profileModal = true
            },
            // 选中menu-item时，手动更新active_menu值-否则手动跳转时不会更新
            mendSelect(name) {
                this.active_menu = name
                // 选择menu-item时, 删除缓存, 使用页面正常刷新
                this.clearCache(name)

            },
            // 清除keep-alive缓存
            clearCache(name) {
                if (
                    this.$refs.main &&
                    this.$refs.main.$options &&
                    this.$refs.main.$options.parent &&
                    this.$refs.main.$options.parent.keys &&
                    this.$refs.main.$options.parent.cache
                ) {
                    const cache = this.$refs.main.$options.parent.cache
                    const keys = this.$refs.main.$options.parent.keys
                    for (let k in cache) {
                        if (
                            !name ||
                            (
                                cache[k] &&
                                cache[k].data &&
                                cache[k].data.attrs &&
                                cache[k].data.attrs.activeMenu == name
                            )
                        ) {
                            if (cache[k] && cache[k].componentInstance) {
                                cache[k].componentInstance.$destroy()
                            }
                            cache[k] = null
                            delete cache[k]
                            const idx = keys.indexOf(k)
                            if (idx > -1) {
                                keys.splice(idx, 1)
                            }
                        }
                    }
                }
            },
            reloadMenus() {
                let that = this
                that.$api.post('/web/session/reloadMenus', {}).then(function(res) {
                    if (res.data.success) {
                        // that.sessionChanged(res.data.session)
                        that.$Message.success({ content: '操作成功', duration: 4, closable: true })
                    }
                })
            },
            sessionChanged(session) {
                if (!session.badge) session.badge = {}
                this.session = session
                if (this.socketReady) {
                    this.socketReady = false
                    this.$socket.emit('join', this.session.token || 1);
                }
                this.checkPagePermission()
                this.updateMenu()
                if (session.delayToLoadBadge) {
                    this.loadBadge()
                }
            },
            toSwitch(zhanghao) {
                let that = this
                if (that.loading) { return }
                that.loading = true
                that.$api.post('/web/session/switch', {
                    zhanghaoId: zhanghao._id,
                }).then(() => {
                    let hash = window.location.hash
                    that.resetNav()
                    window.location.hash = '/'
                    setTimeout(() => {
                        window.location.hash = hash
                        that.loading = false
                        let currentView = that.$refs['main']
                        if (currentView && currentView.sessionChanged) {
                            currentView.sessionChanged()
                        }
                    }, 200)
                }, () => {
                    that.loading = false
                })
            },
            getCode() {
                let that = this
                if (that.logining) { return }
                that.logining = true
                that.$api.post('/web/session/sms/code', {
                    form: that.form,
                }).then(res => {
                    that.logining = false
                    if (res.data.success) {
                        that.codeSend = true
                        that.codeCD = 60
                        that.codeCount()
                    }
                }, () => {
                    that.logining = false
                })
            },
            codeCount() {
                let that = this
                if (that.codeCD > 0) {
                    that.codeCD--
                    setTimeout(() => {
                        that.codeCount()
                    }, 1000)
                }
            },
            login() {
                if (this.logining) { return }
                this.logining = true
                this.resetNav()
                this.$api.post('/web/session/login', {
                    form: this.form,
                }).then(res => {
                    this.logining = false
                    if (res.data.success) {
                        this.codeCD = 0
                        // this.$socket.emit('join', this.session.token || 1);
                        // this.sessionChanged(res.data.session)
                        // this.checkPagePermission()
                    }
                }, () => {
                    this.logining = false
                })
            },
            updateMenu() {
                let that = this
                if (that.session && !that.session.menuGroups) return
                let hash = window.location.hash
                if (hash && hash.indexOf('/logout') != -1) {
                    that.logout()
                } else {
                    for (let menuGroup of this.session.menuGroups) {
                        for (let menu of menuGroup.menus) {
                            if (hash && hash.indexOf(menu.path) != -1) {
                                that.active_menugroup = [menu.group]
                                that.active_menu = menu.key
                                that.$nextTick(function() {
                                    if (that.$refs['menus']) {
                                        that.$refs['menus'].updateOpened()
                                        that.$refs['menus'].updateActiveName()
                                    }
                                })
                                return
                            }
                        }
                    }
                    that.active_menugroup = ['0']
                    that.active_menu = '0'
                    that.$nextTick(function() {
                        if (that.$refs['menus']) {
                            that.$refs['menus'].updateOpened()
                            that.$refs['menus'].updateActiveName()
                        }
                    })
                }
            },
            checkMenu() {
                let that = this
                let hash = window.location.hash
                if (!that.session || !that.session.menuGroups || !hash) return
                // 处理首页
                if (hash && hash.split('/').length === 2) {
                    this.active_menu = '0'
                    this.active_menugroup = ['0']
                    that.$nextTick(function() {
                        if (that.$refs['menus']) {
                            that.$refs['menus'].updateOpened()
                            that.$refs['menus'].updateActiveName()
                        }
                    })
                    return
                }
                for (let menuGroup of this.session.menuGroups) {
                    for (let menu of menuGroup.menus) {
                        if (hash && hash.indexOf(menu.path) != -1) {
                            const active_menu = menu.key
                            if (this.active_menu !== active_menu) {
                                this.active_menu = active_menu
                                this.active_menugroup = [menu.group]
                                that.$nextTick(function() {
                                    if (that.$refs['menus']) {
                                        that.$refs['menus'].updateOpened()
                                        that.$refs['menus'].updateActiveName()
                                    }
                                })
                                return
                            }

                        }
                    }
                }
            },
            closeProfileMenus() {
                this.profileMenusVisible = false
            },
            logout() {
                let that = this
                that.$api.get('/web/session/logout').then(res => {
                    if (res.data.success) {
                        that.sessionChanged(res.data.session)
                        // if (this.socketReady) {
                        //     this.$socket.emit('leave', this.session.token || 1);
                        // }
                        window.location.hash = '/'
                        if (this.form.type == 'scan') {
                            this.resetQrcode()
                        }
                    } else {
                        that.$Message.error(res.data.error)
                    }
                })
            },
            checkPagePermission() {
                let hash = window.location.hash
                if (hash.indexOf('/index') != -1 && hash.indexOf('/logout') != -1) {
                    return window.location.hash = '/'
                }
                // Public pages are not bound to the signed-in menu permissions.
                if (this.isPublicPath((this.$route && this.$route.path) || '')) {
                    return
                }
                let pagepermission = false
                if (this.session.menuGroups && this.session.menuGroups.length) {
                    for (let menuGroup of this.session.menuGroups) {
                        for (let menu of menuGroup.menus) {
                            if (hash.indexOf(menu.path) != -1) {
                                pagepermission = true
                            }
                        }
                    }
                }
                if (!pagepermission) {
                    this.resetNav()
                    window.location.hash = '/'
                }
            },
            turnToPage(route) {
                let { name, params, query } = {}
                if (typeof route === 'string') name = route
                else {
                    name = route.name
                    params = route.params
                    query = route.query
                }
                if (name.indexOf('isTurnByHref_') > -1) {
                    window.open(name.split('_')[1])
                    return
                }
                this.$router.push({
                    name,
                    params,
                    query
                })
            },
            handleClick(item) {
                this.turnToPage(item)
            },
            handleCloseTag(res, type, route) {
                if (type !== 'others') {
                    if (type === 'all') {
                        this.turnToPage('首页')
                    } else {
                        if (routeEqual(this.$route, route)) {
                            this.closeTag(route)
                        }
                    }
                }
                this.setTagNavList(res)
            },
            resetNav() {
                this.clearTag()
                this.clearCache()
            },
            processRoute(to) {
                const { name, query, params, meta } = to
                this.addTag({
                    route: { name, query, params, meta },
                    type: 'push'
                })
                this.setTagNavList(getNewTagList(this.tagNavList, to))
                this.checkMenu()
            }
        },
    }


    function versiontonumber(version) {
        if (!version) return 0
        const parts = version.split('.').map(Number);
        return parts[0] * 1000000 + parts[1] * 1000 + parts[2];
    }

    function version1gtversion2(version1, version2) {
        const parts1 = versiontonumber(version1);
        const parts2 = versiontonumber(version2);
        return parts1 > parts2;
    }
</script>



// WEBPACK FOOTER //
// src/App.vue?7acf3977